'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _actionTypes = require('../widget-data/constants/actionTypes');

var _hasVisitorEmail = require('../widget-data/operators/hasVisitorEmail');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.Map)({
  hasVisitorEmail: false
});

var emailCaptureReducer = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.GET_WIDGET_DATA_SUCCEEDED, function (state, action) {
  var widgetData = action.payload;

  return state.set('hasVisitorEmail', (0, _hasVisitorEmail.hasVisitorEmail)(widgetData));
}), _defineProperty(_handleActions, _actionTypes.REFRESH_WIDGET_DATA, function (state, action) {
  var widgetData = action.payload;

  return state.set('hasVisitorEmail', (0, _hasVisitorEmail.hasVisitorEmail)(widgetData));
}), _defineProperty(_handleActions, ActionTypes.SEND_VISITOR_EMAIL_ADDRESS_SUCCEEDED, function (state) {
  return state.set('hasVisitorEmail', true);
}), _handleActions), initialState);

exports.default = emailCaptureReducer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/email-capture/emailCaptureReducer.js
// module id = 861
// module chunks = 2 3